<div><b>{{ account.nameI18N }}</b>, {{ account.currency }}</div>
<div>
  {{ 'header.bankOwners' | translate }}:
  @for (owner of account.ownerNames; track owner; let isLastOwner = $last) {
    <span class="ml-2">
      {{ owner }}
      @if (!isLastOwner) {
        <span>,</span>
      }
    </span>
  }
</div>
<div>{{ ibanToAccountNumber(account.identification?.iban || '') }}</div>
<div>IBAN: {{ account.identification?.iban || '' }}</div>
